import PostType from '../constants/postType.constants';

const initialPostState = {
  isInitializedByType: {
    all: false,
    myActivity: false,
    nonProfitActivity: false,
    public: false,
    [PostType.Campaign]: false,
    [PostType.Celebration]: false,
  },
  allFeedItems: {},
  postsByType: {
    all: {},
    myActivity: {},
    nonProfitActivity: {},
    public: {},
    [PostType.Campaign]: {},
    [PostType.Celebration]: {},
    [PostType.Volunteering]: {},
    [PostType.Project]: {},
  },
  hasMorePostsByType: {
    all: true,
    myActivity: true,
    nonProfitActivity: true,
    public: true,
    [PostType.Campaign]: true,
    [PostType.Celebration]: true,
    [PostType.Volunteering]: true,
    [PostType.Project]: true,
  },
  hasMoreCommentsByPost: {},
  hasMoreRepliesByComment: {},
  commentsByPost: {},
  mentionedUsers: {},
  currentPostType: null,
  sendingPostId: null,
  editedPostId: null,
  deletedPostId: null,
  reportedPostId: null,
  editingCommentId: null,
  inKindDonationTrigger: {
    postId: null,
    mode: 'donate',
    donationId: null,
  },
  actionTrigger: {
    anchor: null,
    postId: null,
  },
  commentActionTrigger: {
    anchor: null,
    comment: null,
  },
  shareTrigger: {
    post: null,
  },
};

const createPostSlice = (set, get) => ({
  socialFeed: {
    ...initialPostState,
  },
});

export { createPostSlice, initialPostState };
